require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2010-12-16-rackspace-acquires-cloudkick.json") })
        }
      }, "path---articles-2010-12-16-rackspace-acquires-cloudkick");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2010-12-16-rackspace-acquires-cloudkick!./.cache/json/articles-2010-12-16-rackspace-acquires-cloudkick.json
// module id = 608
// module chunks = 231608221292675